import styled from 'styled-components';
import {Space} from 'antd';

const StyledVendorTypeIcon = styled(Space)`
  align-items: center;
  display: flex;
  
  & > .ant-space-item {
    display: flex;
  }
  
  svg {
    height: 24px;
    width: 24px;
    path {
      fill: ${props => props.theme.colors.neutral_7};
    }
  }
`;

export {
  StyledVendorTypeIcon,
};
